import { DefaultDatasetSizeLimiter } from "@/services/license/license-limiters/dataset-size-limiters/default-dataset-size-limiter";

export class EmptyDatasetSizeLimiter extends DefaultDatasetSizeLimiter {
  async getUniqueLimit(userId: string): Promise<number | null> {
    return Promise.resolve(null);
  }
}
